export default {
  cake: {
    56: '0x4deC35b2cCcDBDbEF4910ab13724C2BaD8fA9f98',
    97: '',
  },
  masterChef: {
    56: '0xeC4D912eF139789E30fFB2E0727E8cDd6483663A',
    97: '',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '',
  },
  lottery: {
    56: '0xB375e123D6855280e4601BEA38c206741ab6010b',
    97: '',
  },
  lotteryNFT: {
    56: '0xAbD9fd1FF46Ce3433af688FC6A8c7616645B019c',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '',
  },
  mafia: {
    56: '0x4deC35b2cCcDBDbEF4910ab13724C2BaD8fA9f98',
    97: '',
  },
}
